import React from 'react';
import { Badge, Button, Tooltip } from 'antd';
import { faComments, Icon } from '@/ui/components';
import { useTranslate } from '@/translations';

interface OperatorConversationButtonProps {
  displayName: string;
  unreadCount: number;
  disabled?: boolean;
  onOpen(): void;
}

export const OperatorConversationButton = ({
  displayName,
  unreadCount,
  disabled,
  onOpen,
}: OperatorConversationButtonProps) => {
  const { t } = useTranslate();
  const label = `${t('commsOpenConversation')}: ${displayName}`;

  return (
    <Tooltip title={t('commsOpenConversation')}>
      <Badge count={unreadCount} overflowCount={99} size="small">
        <Button
          type="text"
          disabled={disabled}
          aria-label={label}
          icon={<Icon icon={faComments} />}
          onClick={(event) => {
            event.stopPropagation();
            onOpen();
          }}
        />
      </Badge>
    </Tooltip>
  );
};
